import React, { ReactNode } from 'react';

import { wsApiUrl } from '@services/EndpointUtil';

import { BaseWebSocketProvider } from './BaseWebSocketProvider';

const EXPERIMENTS_CONFIG = {
    url: wsApiUrl('/ws/experiments/'),
    loggerName: 'ExperimentsWebSocket',
    getAuthPayload: (accessToken: string, params?: { experimentUuid?: string }) => ({
        type: 'authenticate',
        Authorization: `Bearer ${accessToken}`,
        experiment_uuid: params?.experimentUuid,
    }),
};

interface ExperimentsWebSocketProviderProps {
    children: ReactNode;
    experimentUuid?: string;
}

class ExperimentsWebSocket extends BaseWebSocketProvider {
    static useWebSocket() {
        return BaseWebSocketProvider.useWebSocket(ExperimentsWebSocket);
    }

    protected validateParams(): boolean {
        const params = this.props.params as { experimentUuid?: string };
        return !!params?.experimentUuid;
    }
}

/**
 * ExperimentsWebSocketProvider always provides its context to allow components to use WebSocket hooks
 * before a connection is established. Instead of conditionally rendering the provider (which would
 * cause "useWebSocket must be used within its WebSocketProvider" errors), we pass an empty URL when
 * experimentUuid is not available, preventing connection attempts until we have all required data.
 */
export function ExperimentsWebSocketProvider({ children, experimentUuid }: ExperimentsWebSocketProviderProps) {
    return (
        <ExperimentsWebSocket {...EXPERIMENTS_CONFIG} params={{ experimentUuid }}>
            {children}
        </ExperimentsWebSocket>
    );
}

// Re-export the hook with experiment-specific naming
export const useWebSocket = ExperimentsWebSocket.useWebSocket;

export default ExperimentsWebSocketProvider;
